"use strict";
import { logger } from "utilities/src/logger/logger";
import { isInterface } from "utilities/src/platform";
export var FeatureFlags = /* @__PURE__ */ ((FeatureFlags2) => {
  FeatureFlags2[FeatureFlags2["ArbitrumDutchV3"] = 0] = "ArbitrumDutchV3";
  FeatureFlags2[FeatureFlags2["BlockaidFotLogging"] = 1] = "BlockaidFotLogging";
  FeatureFlags2[FeatureFlags2["Datadog"] = 2] = "Datadog";
  FeatureFlags2[FeatureFlags2["EmbeddedWallet"] = 3] = "EmbeddedWallet";
  FeatureFlags2[FeatureFlags2["IndicativeSwapQuotes"] = 4] = "IndicativeSwapQuotes";
  FeatureFlags2[FeatureFlags2["InstantTokenBalanceUpdate"] = 5] = "InstantTokenBalanceUpdate";
  FeatureFlags2[FeatureFlags2["MonadTestnet"] = 6] = "MonadTestnet";
  FeatureFlags2[FeatureFlags2["MonadTestnetDown"] = 7] = "MonadTestnetDown";
  FeatureFlags2[FeatureFlags2["PortionFields"] = 8] = "PortionFields";
  FeatureFlags2[FeatureFlags2["SearchRevamp"] = 9] = "SearchRevamp";
  FeatureFlags2[FeatureFlags2["Soneium"] = 10] = "Soneium";
  FeatureFlags2[FeatureFlags2["SwapSettingsV4HooksToggle"] = 11] = "SwapSettingsV4HooksToggle";
  FeatureFlags2[FeatureFlags2["TwoSecondSwapQuotePollingInterval"] = 12] = "TwoSecondSwapQuotePollingInterval";
  FeatureFlags2[FeatureFlags2["UniquoteEnabled"] = 13] = "UniquoteEnabled";
  FeatureFlags2[FeatureFlags2["UniswapX"] = 14] = "UniswapX";
  FeatureFlags2[FeatureFlags2["UniswapXPriorityOrdersBase"] = 15] = "UniswapXPriorityOrdersBase";
  FeatureFlags2[FeatureFlags2["UniswapXPriorityOrdersOptimism"] = 16] = "UniswapXPriorityOrdersOptimism";
  FeatureFlags2[FeatureFlags2["UniswapXPriorityOrdersUnichain"] = 17] = "UniswapXPriorityOrdersUnichain";
  FeatureFlags2[FeatureFlags2["ServiceBasedSwapTransactionInfo"] = 18] = "ServiceBasedSwapTransactionInfo";
  FeatureFlags2[FeatureFlags2["SmartWallet"] = 19] = "SmartWallet";
  FeatureFlags2[FeatureFlags2["ForcePermitTransactions"] = 20] = "ForcePermitTransactions";
  FeatureFlags2[FeatureFlags2["EnablePermitMismatchUX"] = 21] = "EnablePermitMismatchUX";
  FeatureFlags2[FeatureFlags2["ViemProviderEnabled"] = 22] = "ViemProviderEnabled";
  FeatureFlags2[FeatureFlags2["ForceDisableWalletGetCapabilities"] = 23] = "ForceDisableWalletGetCapabilities";
  FeatureFlags2[FeatureFlags2["DisableFiatOnRampKorea"] = 24] = "DisableFiatOnRampKorea";
  FeatureFlags2[FeatureFlags2["ExtensionAutoConnect"] = 25] = "ExtensionAutoConnect";
  FeatureFlags2[FeatureFlags2["NotificationPriceAlertsAndroid"] = 26] = "NotificationPriceAlertsAndroid";
  FeatureFlags2[FeatureFlags2["NotificationPriceAlertsIOS"] = 27] = "NotificationPriceAlertsIOS";
  FeatureFlags2[FeatureFlags2["NotificationOnboardingCard"] = 28] = "NotificationOnboardingCard";
  FeatureFlags2[FeatureFlags2["NotificationUnfundedWalletsAndroid"] = 29] = "NotificationUnfundedWalletsAndroid";
  FeatureFlags2[FeatureFlags2["NotificationUnfundedWalletsIOS"] = 30] = "NotificationUnfundedWalletsIOS";
  FeatureFlags2[FeatureFlags2["OnboardingKeyring"] = 31] = "OnboardingKeyring";
  FeatureFlags2[FeatureFlags2["PrivateRpc"] = 32] = "PrivateRpc";
  FeatureFlags2[FeatureFlags2["Scantastic"] = 33] = "Scantastic";
  FeatureFlags2[FeatureFlags2["SelfReportSpamNFTs"] = 34] = "SelfReportSpamNFTs";
  FeatureFlags2[FeatureFlags2["UwULink"] = 35] = "UwULink";
  FeatureFlags2[FeatureFlags2["BlurredLockScreen"] = 36] = "BlurredLockScreen";
  FeatureFlags2[FeatureFlags2["Eip5792Methods"] = 37] = "Eip5792Methods";
  FeatureFlags2[FeatureFlags2["ExecuteTransactionV2"] = 38] = "ExecuteTransactionV2";
  FeatureFlags2[FeatureFlags2["RestoreSeedPhrase"] = 39] = "RestoreSeedPhrase";
  FeatureFlags2[FeatureFlags2["AATestWeb"] = 40] = "AATestWeb";
  FeatureFlags2[FeatureFlags2["ConversionTracking"] = 41] = "ConversionTracking";
  FeatureFlags2[FeatureFlags2["DummyFlagTest"] = 42] = "DummyFlagTest";
  FeatureFlags2[FeatureFlags2["GoogleConversionTracking"] = 43] = "GoogleConversionTracking";
  FeatureFlags2[FeatureFlags2["GqlTokenLists"] = 44] = "GqlTokenLists";
  FeatureFlags2[FeatureFlags2["LimitsFees"] = 45] = "LimitsFees";
  FeatureFlags2[FeatureFlags2["LpIncentives"] = 46] = "LpIncentives";
  FeatureFlags2[FeatureFlags2["PoolSearch"] = 47] = "PoolSearch";
  FeatureFlags2[FeatureFlags2["PositionPageV2"] = 48] = "PositionPageV2";
  FeatureFlags2[FeatureFlags2["PriceRangeInputV2"] = 49] = "PriceRangeInputV2";
  FeatureFlags2[FeatureFlags2["TraceJsonRpc"] = 50] = "TraceJsonRpc";
  FeatureFlags2[FeatureFlags2["TwitterConversionTracking"] = 51] = "TwitterConversionTracking";
  FeatureFlags2[FeatureFlags2["UniversalSwap"] = 52] = "UniversalSwap";
  FeatureFlags2[FeatureFlags2["BatchedSwaps"] = 53] = "BatchedSwaps";
  return FeatureFlags2;
})(FeatureFlags || {});
export const SHARED_FEATURE_FLAG_NAMES = /* @__PURE__ */ new Map([
  [0 /* ArbitrumDutchV3 */, "uniswapx_dutchv3_orders_arbitrum"],
  [1 /* BlockaidFotLogging */, "blockaid_fot_logging"],
  [2 /* Datadog */, "datadog"],
  [3 /* EmbeddedWallet */, "embedded_wallet"],
  [21 /* EnablePermitMismatchUX */, "enable_permit2_mismatch_ux"],
  [38 /* ExecuteTransactionV2 */, "new_execute_transaction_arch"],
  [23 /* ForceDisableWalletGetCapabilities */, "force_disable_wallet_get_capabilities"],
  [20 /* ForcePermitTransactions */, "force_permit_transactions"],
  [4 /* IndicativeSwapQuotes */, "indicative-quotes"],
  [5 /* InstantTokenBalanceUpdate */, "instant-token-balance-update"],
  [6 /* MonadTestnet */, "monad_testnet"],
  [8 /* PortionFields */, "portion-fields"],
  [9 /* SearchRevamp */, "search_revamp"],
  [18 /* ServiceBasedSwapTransactionInfo */, "new_swap_transaction_info_arch"],
  [19 /* SmartWallet */, "smart-wallet"],
  [10 /* Soneium */, "soneium"],
  [11 /* SwapSettingsV4HooksToggle */, "swap_settings_v4_hooks_toggle"],
  [12 /* TwoSecondSwapQuotePollingInterval */, "two_second_swap_quote_polling_interval"],
  [13 /* UniquoteEnabled */, "uniquote_enabled"],
  [14 /* UniswapX */, "uniswapx"],
  [15 /* UniswapXPriorityOrdersBase */, "uniswapx_priority_orders_base"],
  [16 /* UniswapXPriorityOrdersOptimism */, "uniswapx_priority_orders_optimism"],
  [17 /* UniswapXPriorityOrdersUnichain */, "uniswapx_priority_orders_unichain"],
  [22 /* ViemProviderEnabled */, "viem_provider_enabled"]
]);
export const WEB_FEATURE_FLAG_NAMES = new Map([
  ...SHARED_FEATURE_FLAG_NAMES,
  [40 /* AATestWeb */, "aatest_web"],
  [53 /* BatchedSwaps */, "batched_swaps"],
  [41 /* ConversionTracking */, "conversion-tracking"],
  [42 /* DummyFlagTest */, "dummy_flag_test"],
  [43 /* GoogleConversionTracking */, "google_conversion_tracking"],
  [44 /* GqlTokenLists */, "gql_token_lists"],
  [45 /* LimitsFees */, "limits_fees"],
  [46 /* LpIncentives */, "lp_incentives"],
  [7 /* MonadTestnetDown */, "monad_down"],
  [47 /* PoolSearch */, "pool_search"],
  [48 /* PositionPageV2 */, "position_page_v2"],
  [49 /* PriceRangeInputV2 */, "price_range_input_v2"],
  [50 /* TraceJsonRpc */, "traceJsonRpc"],
  [51 /* TwitterConversionTracking */, "twitter_conversion_tracking"],
  [52 /* UniversalSwap */, "universal_swap"]
]);
export const WALLET_FEATURE_FLAG_NAMES = new Map([
  ...SHARED_FEATURE_FLAG_NAMES,
  [36 /* BlurredLockScreen */, "blurred_lock_screen"],
  [24 /* DisableFiatOnRampKorea */, "disable-fiat-onramp-korea"],
  [37 /* Eip5792Methods */, "eip_5792_methods"],
  [25 /* ExtensionAutoConnect */, "extension-auto-connect"],
  [28 /* NotificationOnboardingCard */, "notification_onboarding_card"],
  [26 /* NotificationPriceAlertsAndroid */, "notification_price_alerts_android"],
  [27 /* NotificationPriceAlertsIOS */, "notification_price_alerts_ios"],
  [29 /* NotificationUnfundedWalletsAndroid */, "notification_unfunded_wallet_android"],
  [30 /* NotificationUnfundedWalletsIOS */, "notification_unfunded_wallet_ios"],
  [31 /* OnboardingKeyring */, "onboarding-keyring"],
  [32 /* PrivateRpc */, "mev-blocker"],
  [39 /* RestoreSeedPhrase */, "restore-seed-phrase"],
  [33 /* Scantastic */, "scantastic"],
  [34 /* SelfReportSpamNFTs */, "self-report-spam-nfts"],
  [35 /* UwULink */, "uwu-link"]
]);
export var FeatureFlagClient = /* @__PURE__ */ ((FeatureFlagClient2) => {
  FeatureFlagClient2[FeatureFlagClient2["Web"] = 0] = "Web";
  FeatureFlagClient2[FeatureFlagClient2["Wallet"] = 1] = "Wallet";
  return FeatureFlagClient2;
})(FeatureFlagClient || {});
const FEATURE_FLAG_NAMES = {
  [0 /* Web */]: WEB_FEATURE_FLAG_NAMES,
  [1 /* Wallet */]: WALLET_FEATURE_FLAG_NAMES
};
export function getFeatureFlagName(flag, client) {
  const names = client !== void 0 ? FEATURE_FLAG_NAMES[client] : isInterface ? FEATURE_FLAG_NAMES[0 /* Web */] : FEATURE_FLAG_NAMES[1 /* Wallet */];
  const name = names.get(flag);
  if (!name) {
    const err = new Error(`Feature ${FeatureFlags[flag]} does not have a name mapped for this application`);
    logger.error(err, {
      tags: {
        file: "flags.ts",
        function: "getFeatureFlagName"
      }
    });
    throw err;
  }
  return name;
}
